import { ChangeDetectorRef, Directive, OnDestroy } from '@angular/core';
import { Subscription, Observable } from 'rxjs';

/**
 * Classe abstraite permettant de lier le cycle de vie des observables au cycle de vie des composants.
 */
@Directive()

export abstract class RxjsComponent implements OnDestroy {
  /**
   * Souscription contenant l'ensemble des souscriptions
   */
  subs: Subscription = new Subscription();

  constructor(protected cdRef?: ChangeDetectorRef) {}

  /**
   * Permet d'ajouter des souscriptions à arrêter à la destruction du composant
   */
  register(...sub: Subscription[]) {
    sub.forEach((s) => this.subs.add(s));
  }

  /**
   * En plus d'ajouter les observables passé en paramètre au tableau de souscription,
   * on déclanche un cycle de détection de changements à chaque nouvelle valeur
   */
  markForCheck(observable: Observable<any>) {
    if (!this.cdRef) {
      throw new Error(`
        L'usage de "markForCheck" nécessite d'avoir la référence du change detector injectée par la classe qui étend RxjsComponent
      `);
    }

    this.register(
      observable.subscribe(
        () => this.cdRef.markForCheck(),
        () => this.cdRef.markForCheck(),
      ),
    );
  }

  /**
   * Détruit toutes les souscriptions à la destruction du composant
   */
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
